import { useEffect } from 'react';

import useOmeMeetEntryInfoData from '../../state/omeMeetEntryInfo/UseOmeMeetEntryInfoData';

const useOmeMeetEntryInfoDropdown = (omeMeetId, isCurrent) => {
  const { omeMeetEntryInfoState, getOmeMeetEntryInfoByOmeMeetId } = useOmeMeetEntryInfoData();

  useEffect(() => {
    if (omeMeetEntryInfoState.isArrayLoading !== true && omeMeetId !== omeMeetEntryInfoState.omeMeetId &&
      omeMeetId > 0 && (isCurrent === true || isCurrent === false)) {
      getOmeMeetEntryInfoByOmeMeetId(omeMeetId, isCurrent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetEntryInfoState, omeMeetId, isCurrent])

  return {
    omeMeetEntryInfoState
  };
};

export default useOmeMeetEntryInfoDropdown;